import { render, staticRenderFns } from "./VarEdit.vue?vue&type=template&id=6136c424&scoped=true&lang=pug"
import script from "./VarEdit.vue?vue&type=script&lang=js"
export * from "./VarEdit.vue?vue&type=script&lang=js"
import style0 from "./VarEdit.vue?vue&type=style&index=0&id=6136c424&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6136c424",
  null
  
)

export default component.exports